import * as React from "react";
import Modal from "../../../ui/modal/Modal";
import SingleFileSelector from "../../../file/SingleFileSelector";
import Toast from "../../../helper/Toast";
import {option} from "ts-option";
import {api} from "../../../../api/api";
import {ImportResult} from "../../../../model/importResult/ImportResult";

interface Props {
	taskId: string
	/**
	 * On successful task items upload callback.
	 */
	onSuccess: () => void;
	/**
	 * On cancel button click.
	 */
	onCancel: () => void;
}

interface IState {
	/**
	 * Indicates if files are uploading
	 */
	filesUploading: boolean;
	/**
	 * Upload errors to display
	 */
	errors: string[];
}

export default class UploadTaskItemsModal extends React.Component<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {filesUploading: false, errors: []};
		this.uploadFile = this.uploadFile.bind(this);
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.onCancel} title={"Upload task items"}>
				<SingleFileSelector onUpload={this.uploadFile}
									onCancel={this.props.onCancel}
									errors={option(this.state.errors)}
									filesUploading={this.state.filesUploading}/>
			</Modal>
		);
	}

	/**
	 * Upload file
	 * @param {File} file
	 */
	uploadFile(file: File) {
		if (file) {
			this.setState({filesUploading: true}, () => {
				api.instance.taskApi.uploadTaskItems(this.props.taskId, file).then(() => {
					Toast.success("Task items uploaded successfully.", "Task items upload");
					this.setState({filesUploading: false});
					this.props.onSuccess();
				}).catch((error: any) => {
					const errors = ImportResult.fromJson(error.response.data);
					this.setState({errors: errors.error, filesUploading: false});
					Toast.error("Cannot upload task items.", "Task items upload");
				});
			});
		}
	}
}
